import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Tooltip from '@material-ui/core/Tooltip';

const PageHeader = ({ title, actions, filters, onSearch, onClearSearch }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [showFilters, setShowFilters] = useState(false);

    return (
        <div>
            <div className="page-header" style={{
                display: 'flex',
                alignItems: 'center',
                gap: isDesktop ? '12px' : '4px',
                flexWrap: 'nowrap',
            }}>
                <Typography display="block" variant="h3" style={{ whiteSpace: 'nowrap', marginRight: 'auto' }}>
                    {title}
                </Typography>
                {isDesktop && filters}
                {isDesktop && (onSearch || onClearSearch) && (
                    <div className="flex-gap-6" style={{ flexShrink: 0 }}>
                        {onSearch && (
                            <IconButton size="small" onClick={onSearch} color="primary">
                                <SearchIcon />
                            </IconButton>
                        )}
                        {onClearSearch && (
                            <IconButton size="small" onClick={onClearSearch}>
                                <CloseIcon />
                            </IconButton>
                        )}
                    </div>
                )}
                {!isDesktop && filters && (
                    <IconButton size="small" onClick={() => setShowFilters(!showFilters)}>
                        <FilterListIcon color={showFilters ? 'primary' : 'inherit'} />
                    </IconButton>
                )}
                {actions && actions.length > 0 && (
                    <div className="flex-gap-6" style={{ flexShrink: 0 }}>
                        {actions.map((action, index) =>
                            isDesktop ? (
                                <Button
                                    key={index}
                                    variant={action.variant || 'contained'}
                                    color={action.color || 'primary'}
                                    onClick={action.onClick}
                                    disabled={action.disabled}
                                    endIcon={action.icon}
                                    size="small"
                                >
                                    {action.label}
                                </Button>
                            ) : (
                                <Tooltip key={index} title={action.label}>
                                    <span>
                                        <IconButton
                                            size="small"
                                            onClick={action.onClick}
                                            disabled={action.disabled}
                                            color={action.color || 'primary'}
                                            className={(action.variant || 'contained') === 'contained'
                                                ? `pp-icon-btn-contained-${action.color || 'primary'}`
                                                : undefined}
                                        >
                                            {action.icon}
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            )
                        )}
                    </div>
                )}
            </div>
            {!isDesktop && showFilters && filters && (
                <div className="table-filter-container">
                    {filters}
                    {(onSearch || onClearSearch) && (
                        <div className="flex-gap-6">
                            {onSearch && (
                                <IconButton size="small" onClick={onSearch} color="primary">
                                    <SearchIcon />
                                </IconButton>
                            )}
                            {onClearSearch && (
                                <IconButton size="small" onClick={onClearSearch}>
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PageHeader;
